import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
const aplCatl = aplCatlCode.CONTACT;

const routes = [{
    path: 'user-contact',
    name: routeName.PROPOSER_INFO_BY_USER,
    component: () => import('@/views/aplCatl640and631/BCBD/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '要保人聯絡資料', leaveAlert: true, code: 'BD', pageTitle: '要保人聯絡資訊', unableBack: true },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.CONTACT_INFO, routeName.CONFIRM_DATA];
        const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
        next(guideRoute);
    },
},
{
    path: 'user-contact-notify',
    name: routeName.NOTIFY_COMPANIES_BY_USER,
    component: () => import('@/views/aplCatl640and631/BCBD/notifyCompanies/Index.vue'),
    meta: { auth: true, metaTitle: '要保人聯絡資料', leaveAlert: true, code: 'BD', pageTitle: '要保人聯絡資訊', unableBack: true },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.PROPOSER_INFO_BY_USER];
        const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
        next(guideRoute);
    },
}];

export default routes;
